import { parsePreferenceMetadata, type UserPreferenceMetadata } from '@/lib/userPreferences';
import { supabase } from '@/lib/supabase';

export type UserPreferencesRow = {
  metadata: UserPreferenceMetadata;
};

/**
 * Loads the current user's preferences row, or null if none exists.
 * Requires RLS policy: authenticated users can SELECT own row.
 */
export async function fetchUserPreferences(
  userId: string,
): Promise<UserPreferencesRow | null> {
  const { data, error } = await supabase
    .from('user_preferences')
    .select('metadata')
    .eq('user_id', userId)
    .maybeSingle();

  if (error) {
    throw error;
  }

  if (!data) return null;

  return { metadata: parsePreferenceMetadata(data.metadata) };
}
